import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { AppValidators } from '../core/validators';
import { Atualizacao, Location, Login } from '../models/location';
import { FormularioService } from './formulario.service';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.scss']
})

export class FormularioComponent implements OnInit {

  @Output() emitSubmit = new EventEmitter();
  formLogin: FormGroup;
  formAtualizacao: FormGroup;
  step: number = 0;
  isLoading: boolean = false;

  intEmail: number = 0;
  intTel: number = 0;
  submitErrado: boolean = false;

  TelErrado: boolean = false;
  TelErrado1: boolean = false;
  TelErrado2: boolean = false;

  emailErrado: boolean = false;
  emailErrado1: boolean = false;
  emailErrado2: boolean = false;

  cepErrado: boolean = false;

  estados: Location[];
  municipios: Location[];
  cpfValid: boolean = true;
  token: string;
  error: boolean = false;
  erromsg: string;

  constructor(
    private fb: FormBuilder,
    private formService: FormularioService,
    private http: HttpClient
  ) { }

  /*
  * @description Inicializar o formulário
  */
  async ngOnInit() {
    this.formLogin = new FormGroup({
      nomeCompleto: new FormControl('', [Validators.required]),
      nomeMae: new FormControl('', [Validators.required]),
      cpf: new FormControl('', [Validators.required, AppValidators.cpf]),
      data_nascimento: new FormControl('', [Validators.required, AppValidators.birthDate]),
    });

    this.formAtualizacao = new FormGroup({
      cpf: new FormControl(''),
      cep: new FormControl('', [Validators.required]),
      complemento: new FormControl(''),
      bairro: new FormControl('', [Validators.required]),
      endereco: new FormControl('', [Validators.required]),
      estado: new FormControl('', [Validators.required]),
      municipio: new FormControl('', [Validators.required]),
      numero: new FormControl('', [Validators.required]),
      telefone1: new FormControl('', [Validators.required]),
      contato: new FormControl('', [Validators.required]),
      email1: new FormControl('', Validators.compose([Validators.email, Validators.required])),
    });

    this.estados = await this.formService.getStates();
  }

  /**
   * @description Buscar CEP
   * @param valor
  */
  buscaCep(valor) {
    if (valor.length == 9) {
      this.formService.CepBusca(valor).subscribe((dados) => this.popularform(dados));
      this.cepErrado = false;
    } else {
      this.cepErrado = true;
    }
  }

  /**
   * @description Carregar os municipios
   * @param event
  */
  async changeEstado(event) {
    this.municipios = [... await this.formService.getMunicipio(event.target.value)];
  }

  /**
   * @description Popular o formulário
   * @param dados
   */
  async popularform(dados) {
    console.log(dados);

    if (!dados.erro) {
      var estado = this.estados.find(x => x.sigla == dados.uf);
      var municipiosLista = [... await this.formService.getMunicipio(estado.id)];
      this.municipios = [... await this.formService.getMunicipio(estado.id)]
      var municipio = municipiosLista.find(x => x.nome.toLowerCase() == dados.localidade.toLowerCase());
      this.formAtualizacao.setValue({
        cpf: this.formAtualizacao.get("cpf").value,
        cep: dados.cep,
        bairro: dados.bairro,
        endereco: dados.logradouro,
        estado: estado.id,
        municipio: municipio.id,
        numero: this.formAtualizacao.get("numero").value,
        complemento: this.formAtualizacao.get("complemento").value,
        telefone1: this.formAtualizacao.get("telefone1").value,
        contato: this.formAtualizacao.get("contato").value,
        email1: this.formAtualizacao.get("email1").value,
      });
      this.cepErrado = false;
    } else {
      this.cepErrado = true;
    }

  }

  addPhone() {
    if (this.intTel == 2) {
    } else {
      this.intTel++;
    }
    if (this.intTel == 1) {
      this.formAtualizacao.addControl('telefone2', new FormControl('', [Validators.required]))
      this.formAtualizacao.addControl('contato_1', new FormControl('', [Validators.required]))
    }
    if (this.intTel == 2) {
      this.formAtualizacao.addControl('telefone3', new FormControl('', [Validators.required]))
      this.formAtualizacao.addControl('contato_2', new FormControl('', [Validators.required]))
    }
  }
  deletePhone() {
    this.intTel--;
    if (this.intTel == 0) {
      this.formAtualizacao.removeControl('telefone2');
      this.formAtualizacao.removeControl('contato_1');
    }
    if (this.intTel == 1) {
      this.formAtualizacao.removeControl('telefone3');
      this.formAtualizacao.removeControl('contato_2');
    }
  }
  addEmail() {
    if (this.intEmail == 2) {
    } else {
      this.intEmail++;
    }
    if (this.intEmail == 1) {
      this.formAtualizacao.addControl('email2', new FormControl('', Validators.compose([Validators.email])))
    }
    if (this.intEmail == 2) {
      this.formAtualizacao.addControl('email3', new FormControl('', Validators.compose([Validators.email])))
    }
  }
  deleteEmail() {
    this.intEmail--;
    if (this.intEmail == 0) {
      this.formAtualizacao.removeControl('email2')
    }
    if (this.intEmail == 1) {
      this.formAtualizacao.removeControl('email3')
    }
  }
  changeSpace(text: any, type: number) {
    text = text.replaceAll(' ', '');
    if (type == 1) {
      this.formAtualizacao.patchValue({ email1: text })
    }
    if (type == 2) {
      this.formAtualizacao.patchValue({ email2: text })
    }
    if (type == 3) {
      this.formAtualizacao.patchValue({ email3: text })
    }
  }

  /**
   * @description Submeter o formulário de login
  */
  async SubitLogin() {
    console.log(this.formLogin.value);
    this.isLoading = true;
    if (this.formLogin.invalid) {
      this.submitErrado = true;
      this.isLoading = false;
    } else {
      const login = new Login({
        nome: this.formLogin.get("nomeCompleto").value,
        nome_mae: this.formLogin.get("nomeMae").value,
        data_nascimento: this.formLogin.get("data_nascimento").value,
        cpf: this.formLogin.get("cpf").value
      });

      try {
        var resp = await this.http.post('https://appredome.clientes.lojainterativa.com/api/external/login', login, { observe: 'response' }).toPromise();
        this.token = resp.body['token'];
        this.isLoading = false;
        this.step = 1;
        this.submitErrado = false;
        if (resp.body['cpf'] == true) {
          this.cpfValid = false
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.step = 2;
        this.submitErrado = false;
      }
    }
  }

  /**
   * @description Submeter o formulário de atualização
  */
  async SubitAtualizacao() {
    console.log(this.formAtualizacao.value);
    this.isLoading = true;
    if (this.formAtualizacao.invalid) {
      this.submitErrado = true;
      this.isLoading = false;
      var tel = this.formAtualizacao.get("telefone1").value;
      var tel1 = this.formAtualizacao.get("telefone2")?.value;
      var tel2 = this.formAtualizacao.get("telefone3")?.value;
      var email = this.formAtualizacao.get("email1").value;
      var email1 = this.formAtualizacao.get("email2")?.value;
      var email2 = this.formAtualizacao.get("email3")?.value;
      if (tel.replace(/[\(\)\.\s-]+/g, '').length < 10 && tel.replace(/[\(\)\.\s-]+/g, '').length != 0) {
        this.TelErrado = true;
      }
      else {
        this.TelErrado = false;
      }
      if (tel1 != undefined) {
        if (tel1.replace(/[\(\)\.\s-]+/g, '').length < 10 && tel1.replace(/[\(\)\.\s-]+/g, '').length != 0) {
          this.TelErrado1 = true;
        }
        else {
          this.TelErrado1 = false;
        }
      }
      if (tel2 != undefined) {
        if (tel2.replace(/[\(\)\.\s-]+/g, '').length < 10 && tel2.replace(/[\(\)\.\s-]+/g, '').length != 0) {
          this.TelErrado2 = true;
        }
        else {
          this.TelErrado2 = false;
        }
      }
      if (this.validacaoEmail(email) == false && email.length != 0) {
        this.emailErrado = true;
      }
      else {
        this.emailErrado = false;
      }
      if (email1 != undefined) {
        if (this.validacaoEmail(email1) == false && email1.length != 0) {
          this.emailErrado1 = true;
        }
        else {
          this.emailErrado1 = false;
        }
      }
      if (email2 != undefined) {
        if (this.validacaoEmail(email2) == false && email2.length != 0) {
          this.emailErrado2 = true;
        }
        else {
          this.emailErrado2 = false;
        }
      }
    }
    else {
      console.log(1);
      this.TelErrado = false;
      this.emailErrado = false;
      let data = this.formAtualizacao.value;

      if (data?.email2 == "") {
        data.email2 = ""
      }
      if (data?.email3 == "") {
        data.email3 == ""
      }
      // console.log("data", data);
      // console.log("data?.telefone2", data?.telefone2);
      // console.log("data?.contato_1", data?.contato_1);
      if (data?.telefone2 == "" || data?.contato_1 == "") {
        data.telefone2 = "";
        // console.log("teste ");

        data.contato_1 = "";
      }
      if (data?.telefone3 == "" || data?.contato_2 == "") {
        data.telefone3 = "";
        data.contato_2 = "";
      }
      var estado = this.estados.find(x => x.id == this.formAtualizacao.get("estado").value);
      const atuali = new Atualizacao({
        cpf: this.formAtualizacao.get("cpf").value,
        cep: this.formAtualizacao.get("cep").value,
        complemento: this.formAtualizacao.get("complemento").value,
        bairro: this.formAtualizacao.get("bairro").value,
        rua: this.formAtualizacao.get("endereco").value,
        estado: estado.nome,
        municipio: this.formAtualizacao.get("municipio").value,
        numero: this.formAtualizacao.get("numero").value,
        telefone: this.formAtualizacao.get("telefone1").value,
        telefone_1: data.telefone2,
        telefone_2: data.telefone3,
        email: this.formAtualizacao.get("email1").value,
        email_1: data.email2,
        email_2: data.email3,
        contato: this.formAtualizacao.get("contato").value,
        contato_1: data.contato_1,
        contato_2: data.contato_2,
      });
      try {
        console.log(atuali);

        var url = 'https://appredome.clientes.lojainterativa.com/api/external/doadores';

        await this.http.put(url, atuali, { observe: 'response', headers: new HttpHeaders().set('Authorization', this.token) }).toPromise()


        this.formLogin.setValue({
          nomeCompleto: "",
          nomeMae: "",
          cpf: "",
          data_nascimento: "",
        });
        this.isLoading = false;
        this.step = 3;
      } catch (error) {
        console.log(error);

        this.erromsg = error.error.message;

        if (error.status == 500) {
          this.erromsg = "Servidor Indisponivel";
        }
        if (error.status == 429) {
          this.erromsg = "Excesso de Requisições";
        }
        if (error.status == 401) {
          this.erromsg = "Token de usuario expirado";
        }
        if (this.erromsg == "") {
          this.erromsg = error.error;
        }

        this.error = true;
        this.isLoading = false;
      }
    }
  }

  /**
   * @description Resetar o formulário
   */
  tentarNovamente() {
    this.isLoading = true;
    this.formLogin.reset()
    this.formAtualizacao.reset()
    this.isLoading = false;
    this.step = 0;
  }

  /**
   * @description Validar o email
   * @param field
  */
  validacaoEmail(field) {
    var usuario = field.substring(0, field.indexOf("@"));
    var dominio = field.substring(field.indexOf("@") + 1, field.length);

    if ((usuario.length >= 1) &&
      (dominio.length >= 3) &&
      (usuario.search("@") == -1) &&
      (dominio.search("@") == -1) &&
      (usuario.search(" ") == -1) &&
      (dominio.search(" ") == -1) &&
      (dominio.search(".") != -1) &&
      (dominio.indexOf(".") >= 1) &&
      (dominio.lastIndexOf(".") < dominio.length - 1)) {
      return true;
    } else {
      return false;
    }
  }
}

function catchError(arg0: (erro: any) => void): any {
  throw new Error('Function not implemented.');
}



